import { render, staticRenderFns } from "./NeedUpgrade.vue?vue&type=template&id=1505ec6e&"
import script from "./NeedUpgrade.vue?vue&type=script&lang=js&"
export * from "./NeedUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports